module.exports = __webpack_public_path__ + "static/media/saltout.097f9524.svg";